import React, { lazy } from 'react';
import { XCircle } from 'lucide-react';
const problems = ['Noche buscando en Google "por qué mi hijo no puede dormir solo" y encontrando respuestas que se contradicen', 'Acostarte a las 11 PM y levantarte 4 veces antes de las 6 AM sin saber qué está pasando', 'Siempre el mismo cuento de 45 minutos, las mismas negociaciones, las mismas idas y vueltas', 'El miedo a la oscuridad, los monstruos, las pesadillas — sin saber si lo que hacés ayuda o empeora', 'Cambios de casa, viajes, jardín nuevo — y el sueño que se rompe cada vez como si empezaras de cero', 'Fin de semana agotado, domingo te acostás sabiendo que la noche que viene va a ser igual'];
export function ProblemSection() {
  return <section className="bg-charcoal text-white pt-0 pb-[27px]" data-id="element-292">
      <div className="overflow-hidden" data-id="element-293">
        <img src="https://cdn.magicpatterns.com/uploads/rFexdWsMmuzVgtGAxDzeXb/Definitiva.png" alt="MegaPack Descanso Profundo Listo - Rutinas de sueño efectivas y comprobadas" className="w-full object-cover object-center" loading="lazy" decoding="async" data-id="element-294" />
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-6" data-id="element-295">
        <p className="text-center text-gold font-semibold text-lg mb-1 uppercase tracking-wider" data-id="element-296">
          ¿Cuántas noches más vas a pasar así?
        </p>
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-297">
          Sos padre o madre. Amás a tu hijo con todo.
        </h2>

        <div className="space-y-5 text-lg text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-298">
          <p className="flex items-start gap-3" data-id="element-299">
            <span className="text-gold text-xl mt-0.5" data-id="element-300">→</span>
            Pero nadie te dijo que la crianza implicaba perder el sueño — el
            tuyo y el de él — durante años sin saber qué hacer.
          </p>
          <p className="mt-6 font-semibold text-gold text-center text-xl" data-id="element-301">
            No es falta de amor. Es falta de un sistema.
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-xl p-6 md:p-8 space-y-4" data-id="element-302">
          {problems.map((problem, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-303">
              <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-304" />
              <p className="text-gray-200" data-id="element-305">{problem}</p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-306">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold italic" data-id="element-307">
            ¿Y si esta fuera la última noche que pasás sin saber qué hacer?
          </h3>
        </div>
      </div>
    </section>;
}